export const numbersOnly = (str,isFloat=false) => {
    const pattern = isFloat ? /[^\d|\.]/g : /\D/g
    return ('' + str).replace(pattern, '')
}

export const isEmpty = (str)=>{
    return (str || '').trim() === '';
}

export const isNumeric = (str)=>{
    if (typeof str === 'number') return true;
    if (typeof str != "string") return false // we only process strings!  
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
           !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
};

export const formatComma = (num) => {
    let numStr = num + '';
    let dotInd = numStr.indexOf('.');
    let deciStr = '';
    if (dotInd > -1) {
        deciStr = numStr.slice(dotInd, dotInd + 2);
        numStr = numStr.slice(0, dotInd);
    }

    if (numStr.length > 3) {
        let count = 1;
        for (let i = numStr.length - 1; i > 0; i--) {
            if (count === 3) {
                numStr = numStr.slice(0, i) + ',' + numStr.slice(i);
                count = 0;
            }
            count++;
        }
    }
    numStr += deciStr;
    return numStr;
}